import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { useNavigate, useRoutes } from 'react-router';
import { EVO_APPS, LOGIN_ERROR_ROUTE, LOGIN_ORG_ROUTE, LOGIN_ROUTE, LOGIN_SILENT, LOGIN_SUCCESS_ROUTE, LOGOUT_ROUTE, LOGOUT_SUCCESS_ROUTE, } from '../../constants';
import { isLoggedInWithBentleyToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { getAuthUrl, getBentleyAuthUrl } from '../../util/getAuthUrl';
import { ErrorRedirect } from '../errorRedirect/errorRedirect';
import { BentleyLoginExtend } from '../loginExtend/BentleyLoginExtend';
import { BentleyLoginSuccess } from '../loginSuccess/BentleyLoginSuccess';
import { LoginSuccess } from '../loginSuccess/LoginSuccess';
import { BentleyLogout } from '../logout/BentleyLogout';
import { Logout } from '../logout/Logout';
import { CentralOrgSelector } from '../orgSelector/centralOrgSelector/CentralOrgSelector';
import { BentleyOrgHubSelector } from '../orgSelector/orgHubSelector/BentleyOrgHubSelector';
import { OrgHubSelector } from '../orgSelector/orgHubSelector/OrgHubSelector';
import { AccessTokenGuard } from '../routeGuards/AccessTokenGuard';
import { BentleyAccessTokenGuard } from '../routeGuards/BentleyAccessTokenGuard';
import { SkipOrgSelector } from '../skipOrgSelector/SkipOrgSelector';
import { DEFAULT_BACKGROUND_IMAGES, LoginContext } from './LoginContext';
function renderRoutes(isUsingBentley, guardedRoutes, additionalScopes) {
    return isUsingBentley ? (_jsx(BentleyAccessTokenGuard, { additionalScopes: additionalScopes, children: guardedRoutes })) : (_jsx(AccessTokenGuard, { children: guardedRoutes }));
}
export function LoginHandler({ guardedRoutes, LandingPage, LandingPageLogo, store, homePagePath, service, includeClientSecret = false, imageList = DEFAULT_BACKGROUND_IMAGES, useOrgSelector = false, forceOauthPrefix = false, createId = true, displayComingSoon = false, additionalScopes = [], bentleyIdEnabled = false, evoNextEnabled = false, }) {
    const isLoggedInWithBentley = isLoggedInWithBentleyToken();
    const navigate = useNavigate();
    const authCallback = useCallback(() => bentleyIdEnabled
        ? getBentleyAuthUrl({
            forceOauthPrefix,
            additionalScopes,
        })
        : getAuthUrl(forceOauthPrefix, additionalScopes), [bentleyIdEnabled, additionalScopes, forceOauthPrefix]);
    const [loginContext] = useState({
        imageList,
        includeClientSecret,
        forceOauthPrefix,
        service,
    });
    let orgComponent = _jsx(SkipOrgSelector, { homePagePath: homePagePath });
    if (service === 'central') {
        orgComponent = _jsx(CentralOrgSelector, { homePagePath: homePagePath });
    }
    if (EVO_APPS.includes(service)) {
        orgComponent = (_jsx(BentleyOrgHubSelector, { evoNextEnabled: evoNextEnabled, homePagePath: homePagePath }));
    }
    else if (useOrgSelector) {
        orgComponent = _jsx(OrgHubSelector, { homePagePath: homePagePath });
    }
    const routes = useRoutes([
        {
            path: '*',
            element: renderRoutes(bentleyIdEnabled, guardedRoutes, additionalScopes),
        },
        {
            path: LOGIN_ROUTE,
            element: (_jsx(LandingPage, { createId: createId, getSignInUrl: authCallback, Logo: LandingPageLogo, displayComingSoon: displayComingSoon })),
        },
        {
            path: LOGIN_ERROR_ROUTE,
            element: _jsx(ErrorRedirect, {}),
        },
        {
            path: LOGIN_SUCCESS_ROUTE,
            element: bentleyIdEnabled ? _jsx(BentleyLoginSuccess, {}) : _jsx(LoginSuccess, {}),
        },
        {
            path: LOGIN_SILENT,
            element: _jsx(BentleyLoginExtend, {}),
        },
        {
            path: LOGIN_ORG_ROUTE,
            element: orgComponent,
        },
        {
            path: LOGOUT_ROUTE,
            element: isLoggedInWithBentley ? _jsx(BentleyLogout, {}) : _jsx(Logout, {}),
        },
        {
            path: LOGOUT_SUCCESS_ROUTE,
            element: (_jsx(LandingPage, { createId: createId, getSignInUrl: authCallback, Logo: LandingPageLogo, displayComingSoon: displayComingSoon })),
        },
    ]);
    useEffect(() => {
        if (bentleyIdEnabled && isLoggedInWithBentley === false) {
            navigate('/logout');
        }
        if (!bentleyIdEnabled && isLoggedInWithBentley === true) {
            navigate('/logout');
        }
    }, [bentleyIdEnabled, isLoggedInWithBentley, navigate]);
    return (_jsx(Provider, { store: store, children: _jsx(LoginContext.Provider, { value: loginContext, children: routes }) }));
}
//# sourceMappingURL=LoginHandler.js.map